import { render, staticRenderFns } from "./Merkliste.vue?vue&type=template&id=79afd630&scoped=true&"
import script from "./Merkliste.vue?vue&type=script&lang=js&"
export * from "./Merkliste.vue?vue&type=script&lang=js&"
import style0 from "./Merkliste.vue?vue&type=style&index=0&id=79afd630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79afd630",
  null
  
)

export default component.exports